import React from 'react';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { States } from '../../features/PpsiContainer/constants';
import { ppsiPublishedRoute } from '../../routes';
import { getPpsiById } from '../../features/PpsiContainer/selectors';

const PublishedInstructionLink = ({ data, visible = true }) => {
  const { ppsiId } = data;
  const ppsi = useSelector(getPpsiById(ppsiId));
  const publishedStatus =
    ppsi && ppsi.getIn(['publishedPpsiEnrichmentData', 'status']);
  if (!publishedStatus || !visible) {
    return null;
  }
  const linkText =
    publishedStatus === States.PUBLISHED
      ? 'Published instruction'
      : 'Unpublished instruction';
  return (
    <Typography variant="body2">
      <Link
        component={RouterLink}
        to={ppsiPublishedRoute(ppsiId)}
        color="secondary"
      >
        {linkText}
      </Link>{' '}
      exists
    </Typography>
  );
};

export default PublishedInstructionLink;
